export default __webpack_public_path__ + "static/media/etapa7.e1a25fdf.png";